module.exports = __webpack_public_path__ + "static/media/downloadButton.cd03d762.svg";